import {
  ChangeDetectionStrategy,
  Component,
  model,
  output,
} from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { DmButtonLibComponent } from '@everymatrix-base-components/dm-button-lib';
import { ProgressSpinner } from 'primeng/progressspinner';

@Component({
  selector: 'lib-delete-template-modal',
  standalone: true,
  imports: [DialogModule, DmButtonLibComponent, ProgressSpinner],
  template: `
    <p-dialog [(visible)]="visible" [modal]="true" [style]="{ width: '460px' }">
      <div class="modal-container">
        <div class="info-container">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 7C12.5523 7 13 7.44772 13 8V12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12V8C11 7.44772 11.4477 7 12 7ZM11 16C11 15.4477 11.4477 15 12 15H12.01C12.5623 15 13.01 15.4477 13.01 16C13.01 16.5523 12.5623 17 12.01 17H12C11.4477 17 11 16.5523 11 16Z"
              fill="#D6421E"
            />
          </svg>
        </div>
        <div class="title">
          <span>{{ title() }}</span>
        </div>
        <div class="description">
          <span [innerHTML]="description()"> </span>
        </div>
      </div>
      <ng-template pTemplate="footer">
        <div
          style="width: 100%; display: flex; flex-direction: row; justify-content: space-between"
        >
          <lib-dm-button-lib
            text="Cancel"
            size="medium"
            variant="secondary-outlined"
            (outsideClickEmitter)="visible.set(false)"
          />
          <lib-dm-button-lib
            text="Delete"
            size="medium"
            variant="destructive-filled"
            (outsideClickEmitter)="loading.set(true); confirm.emit(true)"
          >
            @if(loading()) {
            <div class="dm-button-icon" icon-left>
              <p-progress-spinner
                strokeWidth="6"
                [style]="{ width: '20px', height: '20px' }"
              />
            </div>
            }
          </lib-dm-button-lib>
        </div>
      </ng-template>
    </p-dialog>
  `,
  styleUrls: ['./delete-template-modal.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteTemplateModalComponent {
  visible = model(false);
  loading = model(false);
  title = model('');
  description = model('');

  confirm = output<boolean>();
}
